export const mobileLoginCookieKey = 'mobile_login_flow';
export const clinicianBridgeParamsStorageKey = 'clinician_bridge_v2_login_params';

export const CLINICIAN_APP_CALLBACK_URIS = [
  'co.onestep.clinicianapp://auth/callback',
  'co.onestep.clinicianapp.dev://auth/callback',
  // The App Store build's bundle identifier is `co.onestep.ClinicianApp` (Apple treats bundle
  // ids as case-insensitive for uniqueness, so the lowercase form above could never be
  // registered as its own App ID). The app derives this URI from its bundle id at runtime, and
  // the check against this list is an exact match, so the cased variant needs its own entry.
  'co.onestep.ClinicianApp://auth/callback',
];
export const BRIDGE_PARAM_CODE_CHALLENGE = 'code_challenge';
export const BRIDGE_PARAM_STATE = 'state';
export const BRIDGE_PARAM_REDIRECT_URI = 'redirect_uri';
export const CLINICIAN_BRIDGE_PARAMS_TTL_MINUTES = 15;
export const SSO_REQUIRED_ERROR_MESSAGE = 'sso: user must authenticate using SSO';
export const LOGIN_REFUSED_ERROR = 'login_refused';
